import React, { useState, useEffect } from 'react';

const DoneButton = ({stepId, list, updateDoneStepStateList}) => {
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    const stepState = list.find(s => s._id === stepId);
    if (stepState) {
      setIsComplete(stepState.done);
      console.log('[DoneButton] Sync from list', { stepId, done: stepState.done });
    } else {
      console.warn('[DoneButton] Step not found in list for sync', { stepId });
    }
  }, [list, stepId]);

  const buttonStyles = {
    
    borderRadius: '10px',
    border: '1px solid #ccc',
    backgroundColor: isComplete ? '#4CAF50' : '#ffffff',
    color: isComplete ? '#ffffff' : '#000000',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    outline: 'none',
    fontSize: '14px',
    height: '24px',
    width: '78px',
    marginRight: '10px'
  };

  const handleClick = () => {
    const next = !isComplete;
    console.log('[DoneButton] Click', { stepId, from: isComplete, to: next });
    setIsComplete(next);
    updateDoneStepStateList(stepId, next);
  };

  return (
    <div className="stepButton" style={buttonStyles} onClick={handleClick}>
      <p style={{textAlign: 'center',marginTop:"4px"}}>{isComplete ? 'Complete' : 'Done'}</p>
    </div>
  );
};

export default DoneButton;